@if (pointIsRoutable) {
  <div class="planned-ride-stop-container">
    @if (!popupMode && points.length === 1) {
      <div class="stop-list" i18n>
        Stop<span class="rounded-display" [ngClass]="color ? ('profile-' + color | lowercase) : 'primary-bg'">{{
          points[0].stopNumber
        }}</span
        >in route
      </div>
    }
    @if (!popupMode && points.length > 1) {
      <div class="stop-list" i18n>
        Stops
        @for (point of points; track $index) {
          <span class="rounded-display" [ngClass]="color ? ('profile-' + color | lowercase) : 'primary-bg'">{{
            point.stopNumber
          }}</span>
        }
        in route
      </div>
    }
    @if (popupMode && canAdd) {
      <button
        class="button stop-number-button"
        type="button"
        rdxAnalytics="Add To Route From Popup"
        [id]="isAddAgain ? 'addWaypoint' : 'addWaypointAgain'"
        [rdxAnalyticsData]="entityType"
        [ngClass]="{
          'secondary-button': isAddAgain || isViapoint,
          'primary-button': !(isAddAgain || isViapoint),
          'disabled-button': disableButton
        }"
        (click)="addMapPointToPlannedRide.emit()"
      >
        <span class="rounded-display" [ngClass]="color ? ('profile-' + color | lowercase) : 'primary-bg'">{{
          nextStopNumber
        }}</span>
        @if (!isAddAgain) {
          <span class="button-label" i18n>Add Stop</span>
        }
        @if (isAddAgain) {
          <span class="button-label" i18n>Add Again</span>
        }
      </button>
    }
    @if (canDelete) {
      <button
        id="remove-waypoint"
        class="button secondary-button"
        type="button"
        rdxAnalytics="Remove From Route Click"
        [rdxAnalyticsData]="entityType"
        (click)="delete()"
      >
        <svg-icon
          src="/assets/icons/trash.svg"
          svgClass="delete-icon"
          svgAriaLabel="Remove Waypoint"
          i18n-svgAriaLabel
        />
        @if (!canAdd && popupMode) {
          <span class="button-label" i18n>Remove Stop</span>
        }
        @if (canDeleteSegments || points.length > 1) {
          <svg-icon src="/assets/icons/downarrow.svg" svgAriaLabel="Open Delete Menu" i18n-svgAriaLabel />
        }
      </button>
    }

    @if (!popupMode && (ride?.points?.length ?? 0) >= maxPoints) {
      <rdx-planned-ride-warning-message />
    }

    @if (!popupMode && canAdd) {
      <button
        class="stop-number-button button"
        type="button"
        rdxAnalytics="Add To Route From Sidebar"
        [id]="isAddAgain ? 'addWaypoint' : 'addWaypointAgain'"
        [ngClass]="{
          'secondary-button': isAddAgain || isViapoint,
          'primary-button': !(isAddAgain || isViapoint),
          'disabled-button': disableButton
        }"
        [rdxAnalyticsData]="entityType"
        (click)="addMapPointToPlannedRide.emit()"
      >
        <span class="rounded-display" [ngClass]="color ? ('profile-' + color | lowercase) : 'primary-bg'">{{
          nextStopNumber
        }}</span>
        @if (!isAddAgain) {
          <span class="button-label" i18n>Add Stop</span>
        }
        @if (isAddAgain) {
          <span class="button-label" i18n>Add Again</span>
        }
      </button>
    }
    <div class="delete-buttons-container" [hidden]="!isShowingViapointDeleteOptions">
      <a
        id="deletePoint"
        class="delete-button"
        href="javascript: void(0);"
        rdxAnalytics="Remove Single Viapoint From Route"
        (click)="emitDelete()"
      >
        <img
          alt="Remove single point from planned ride."
          aria-label="Map Point"
          ngSrc="/assets/icons/map-point.svg"
          i18n-alt
          i18n-aria-label
        />
        <span class="delete-option-label" i18n>Remove Point</span>
      </a>
      <a
        id="deleteSegment"
        class="delete-button"
        href="javascript: void(0);"
        rdxAnalytics="Remove Viapoint Segment From Route"
        (click)="emitDelete(undefined, true)"
      >
        <img
          alt="Remove segment from planned ride."
          aria-label="Map Segment"
          ngSrc="/assets/icons/map-segment.svg"
          i18n-alt
          i18n-aria-label
        />
        <span class="delete-option-label" i18n>Remove All Points</span>
      </a>
    </div>
    <div
      class="delete-buttons-container delete-waypoint-container"
      [hidden]="!isShowingWaypointDeleteOptions"
      [ngClass]="{ 'sidebar-mode': !popupMode, higher: !popupMode && canAdd }"
    >
      @for (point of points; track $index) {
        <a
          class="delete-button delete-waypoint"
          href="javascript: void(0);"
          rdxAnalytics="Remove Waypoint From Route"
          [rdxAnalyticsData]="entityType"
          (click)="emitDelete(point)"
        >
          <span class="rounded-display" [ngClass]="color ? ('profile-' + color | lowercase) : 'primary-bg'">{{
            point.stopNumber
          }}</span>
          <span class="delete-option-label" i18n>Remove Stop</span>
        </a>
      }
    </div>
  </div>
}
